<vex-page-layout>
    <vex-page-layout-content>
      <div class="container">
        <form [formGroup]="loadingOrderForm">
          <div class="header">
            <h1># {{orderNumber}}</h1>
            
            <div>
            <button
            class="ml-2"
            color="primary"
            mat-stroked-button
            type="button"
            (click)="onBack()">
            <mat-icon svgIcon="mat:arrow_back"></mat-icon> {{"BACK.TEXT"|translate}}
          </button>
          <!-- Hidden report template used for PDF generation -->
          <button
            class="ml-2"
            color="primary"
            mat-flat-button
            type="button"
            (click)="generatePdf()">
            <mat-icon svgIcon="mat:print"></mat-icon> {{"PRINT.TEXT"|translate}}
          </button>
        </div>
          </div>
          <app-loading-order-pdf #hiddenReport [orderData]="data" [transporters]="transporters" [vehicles]="vehicles" [drivers]="drivers"></app-loading-order-pdf>

          <mat-card>
            <mat-card-content>
              <mat-card-title>{{"FROM_FACTORY.TEXT"|translate}}</mat-card-title>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{"FACTORY.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  placeholder="Search Factory"
                  formControlName="factoryName" />
  
                <mat-select #factorySelect required formControlName="factoryId">
                  <mat-option
                    *ngFor="let factory of filteredfactories"
                    [value]="factory.id">
                    {{ factory.code }} - {{ factory.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-card-content>
          </mat-card>
  
          <mat-card>
            <mat-card-content>
              <mat-card-title>{{"TO_CLIENT.TEXT"|translate}}</mat-card-title>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{"CLIENT_NAME.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  placeholder="Search Client"
                  formControlName="customerName" />
  
                <mat-select #customerSelect required formControlName="customerId">
                  <mat-option
                    *ngFor="let customer of filteredCustomers"
                    [value]="customer.id">
                    {{ customer.code }} - {{ customer.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{"LOCATION.TEXT"|translate}}</mat-label>
                <input
                  matInput
                  formControlName="customerAddressName" />
                <mat-select formControlName="customerAddressName" required>
                  <mat-option
                    *ngFor="let location of customerLocations"
                    [value]="location.id"
                    >{{ location.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <a
              [href]="'https://www.google.com/maps?q=' + this.latitude + ',' + this.longitude"
              target="_blank"
              class="text-red-600 flex items-center space-x-1"
            >
              <span>{{"VIEW_ON_MAP.TEXT"|translate}}</span>
              <mat-icon svgIcon="mat:map"></mat-icon>
            </a>

            </mat-card-content>
          </mat-card>
  
          <mat-card>
            <mat-card-content>
              <mat-card-title>{{"PRODUCT_VEHICLE_DETAILS.TEXT"|translate}}</mat-card-title>
              <div class="row">
                <!-- <mat-form-field appearance="outline" class="half-width">
              <mat-label>Product</mat-label>
              <mat-select required formControlName="productId">
                <mat-option
                  *ngFor="let product of products"
                  [value]="product.id"
                  >{{ product.name }}</mat-option
                >
              </mat-select>
            </mat-form-field> -->
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>{{"PRODUCT.TEXT"|translate}}</mat-label>
                  <input
                    matInput
                    placeholder="Search Product"
                    formControlName="productName" />
  
                  <mat-select #productSelect required formControlName="itemId">
                    <mat-option
                      *ngFor="let product of filteredProducts"
                      [value]="product.id">
                      {{ product.code }} - {{ product.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
  
              <div class="row">
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>{{ "QUANTITY.TEXT" | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="quantity"
                    required
                    placeholder="Enter Quantity"
                    type="number" />
                </mat-form-field>
  
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>{{"TYPE_OF_VEHICLE.TEXT"|translate}}</mat-label>
                  <input
                    matInput
                    placeholder="My description"
                    [disabled]="true" />
                </mat-form-field>
              </div>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ "DELIVERY_NUMBER.TEXT" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="deliveryNumber"
                  
                  placeholder="Enter Delivery Number"
                  type="number" />
              </mat-form-field>
            </mat-card-content>
          </mat-card>
  
          <mat-card>
            <mat-card-content>
              <mat-card-title>{{"ADDITIONAL_DETAILS.TEXT"|translate}}</mat-card-title>
  
              <div class="row">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>{{"CUSTOMER_REFERENCE_NO.TEXT"|translate}}</mat-label>
                  <input
                    matInput
                    formControlName="customerRefNo"
                    placeholder="Enter Reference No"
                    required />
                </mat-form-field>
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>{{"TRANSACTION_DATE.TEXT"|translate}}</mat-label>
                  <input
                    matInput
                    formControlName="transactionDate"
                    [matDatepicker]="picker" />
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
  
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>{{"NO_OF_REQUESTS.TEXT"|translate}}</mat-label>
                  <input
                    matInput
                    formControlName="numberOfRequests"
                    type="number"
                    placeholder="Enter Amount"
                    required />
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
  
          <mat-card>
            <mat-card-content>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{"TRANSPORTER.TEXT"|translate}}</mat-label>
                <mat-select required formControlName="transporterId">
                  <mat-option
                    *ngFor="let transporter of transporters"
                    [value]="transporter.id"
                    >{{ transporter.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
  
              <div class="row">
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>{{"TRUCK.TEXT"|translate}}</mat-label>
                  <mat-select required formControlName="vehicleId">
                    <mat-option
                      *ngFor="let vehicle of vehicles"
                      [value]="vehicle.id"
                      >{{ vehicle.name }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
  
                <mat-form-field appearance="outline" class="half-width">
                  <mat-label>{{"DRIVER.TEXT"|translate}}</mat-label>
                  <mat-select required formControlName="driverId">
                    <mat-option
                      *ngFor="let driver of drivers"
                      [value]="driver.id"
                      >{{ driver.firstName }} {{ driver.lastName }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </div>
    </vex-page-layout-content>
  </vex-page-layout>
  